<template>
	<card :type="strAccessType" class="reSearchCardStaff">
		<div class="card-user" @dblclick="OpenCard(objStaff.code);">
			<div class="left_part">
				<div class="avatarBlk author">
					<div class="photo"><img class="avatar" :src="$GVO.endpoint_domen+'/ajaxdata/getImg.php?code='+objStaff.code" /></div>
					<div class="onlineStatus" :class="[{'online':bOnlineStatus},{'offline':!bOnlineStatus}]">
						<i></i>
						<h5 class="title mb-1">{{strOnline}}</h5>
					</div>
					<div class="roles">
						<span class="badge badge-pill badge-success" v-if="objStaff.adm == '1'">Администратор системы</span>
							<template v-if="objStaff.roles_text && objStaff.roles_text.length>0">
							<span class="badge badge-pill badge-success" v-for="role in objStaff.roles_text" :key="role">{{ role }}</span>
						</template>
					</div>
				</div>
				<div class="fioBlk">
					<div>
						<h4 class="title">{{strFIO}}</h4>
						<p class="description" v-if="!$GVO.isEmpty(objStaff.pozname)">{{objStaff.pozname}}</p>
					</div>
					<base-button @click="OpenCard(objStaff.code);" type="primary" simple>Посмотреть</base-button>
				</div>
			</div>
			<div class="right_part">
				<div class="contactsBlk">
					<p v-if="!$GVO.isEmpty(objStaff.phoneMedia)" class="description"><span class="d-inline-block mr-2">Рекламный тел.</span> <a :href="`tel:${objStaff.phoneMedia}`" class="d-inline-block mr-1 text-success"><i class="d-inline-block tim-ic ic-phone"></i><span>{{objStaff.phoneMedia}}</span> </a></p>
					<p v-if="!$GVO.isEmpty(objStaff.InternalPhone)" class="description"><span class="d-inline-block mr-2">Внутренний тел.</span> <a :href="`tel:${objStaff.InternalPhone}`" class="d-inline-block mr-1 text-success"><i class="d-inline-block tim-ic ic-phone"></i><span>{{objStaff.InternalPhone}}</span> </a></p>
					<p v-if="!$GVO.isEmpty(objStaff.email)" class="description"><span class="d-inline-block mr-2">E-mail</span> <a :href="`mailto:${objStaff.email}`" class="d-inline-block mr-1 text-primary"><i class="d-inline-block tim-icons icon-email-85"></i><span>{{objStaff.email}}</span></a></p>
					<!-- <p class="description"><span class="d-inline-block mr-2">Написать</span> <a href="#" class="d-inline-block mr-1 text-success"><i class="d-inline-block tim-icons icon-send"></i><span>личное сообщение</span> </a></p> -->
				</div>
				<div class="orgBlk">
					<ReBranchPrint v-if="typeof objStaff.Branch != 'undefined' && objStaff.Branch.allBranchArrRecur.length > 0" :masBranch="objStaff.Branch.allBranchArrRecur"/>
				</div>
			</div>
		</div>
	</card>
</template>

<script>
	import ReBranchPrint from 'src/our_components/ReBranchPrint.vue';
	export default {
		name: 'ReSearchCardStaff',
		components: {
			ReBranchPrint,
		},
		props: {
			objStaff: Object,
		},
		data () {
			return {
				ver: 1,
				strAccessType: 'staffRO',
				//bOnlineStatus: true,
			}
		},
		computed: {
			strFIO: function(){
				return [this.objStaff.lastName,this.objStaff.firstName,this.objStaff.fatherName].join(' ');
			},
			bOnlineStatus: function(){
				if(this.objStaff.online == 1){
					return true;
				}
				return false;
			},
			strOnline: function(){
				if(this.bOnlineStatus){
					return 'онлайн';
				}else{
					return 'оффлайн';
				}
			},
			Call(strPhone,obj_type,obj_id){
				return this.$GVO.Call(strPhone,obj_type,obj_id);
			},
		},
		methods: {
			OpenCard: function(code){
				this.$router.push({path: '/data/staff/id/'+code});
			}
		},
	}
</script>
<style scoped>
	.reSearchCardStaff {border: 1px solid #9e77f3;  box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25)!important;}

	.reSearchCardStaff .card-user{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	.card-user .left_part, .card-user .right_part{
		width: 100%;
		display: flex;
		flex-flow: row nowrap;
	}
	/*.card-user .left_part{}*/
	.card-user .right_part{justify-content: space-between;}
	.card-user .right_part > *{display: inline-block; vertical-align: top;}

	.avatarBlk{width:250px;}
	.avatarBlk .avatar{
		object-fit: contain;
		background-color: white;
	}
	
	.onlineStatus{text-align: center;}
	.onlineStatus > *{display: inline-block;}
	.onlineStatus i{
		width: 7px;
		height: 7px;
		border-radius: 50%;
		margin-right: 5px;
	}
	.onlineStatus.online i{background-color: greenyellow;}
	.onlineStatus.offline i{background-color: red;}

	.fioBlk, .contactsBlk, .orgBlk{margin-top: 35px;}
	.fioBlk {display: flex; flex-direction: column; justify-content: space-between;}

	p.description{font-size: 1em;}
	p.description a > i{ margin-right: 5px;}

	.roles {
		display: flex;
		flex-direction: column;
		padding: 0 15px 0 5px;
		align-items: center;
	}
	.roles .badge {width: fit-content;}


	@media (max-width: 1100px){
		.card-user .orgBlk{display:none;}
	}
	@media (max-width: 600px){
		.reSearchCardStaff .card-user{
			display: block;
		}
		.card-user .left_part, .card-user .right_part{display: block;}
	}
</style>
